.chat_input {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  padding: 8px 4px 0 4px;
  border-top: 1px solid
    var(--ion-color-light-shade, #e0e0e0);
}

.textarea {
  flex: 1;
  --padding-start: 12px;
  --padding-end: 12px;
  border: 1px solid var(--ion-color-medium);
  border-radius: 8px;
}
